import { atomWithKey as atom } from "./atomWithKey";
import { IPreferredLanguage } from "../Types/Index";
import { ISupportedLocales } from "../Types/Interface/ICustomer";

export const languagesResponseAtom = atom<IPreferredLanguage[]>({
    key: "languagesResponseAtom",
    default: [],
});
export const languageDropdownOpenAtom = atom<boolean>({
    key: "languageDropdownOpenAtom",
    default: false,
});
export const localeLanguageAtom = atom<ISupportedLocales>({
    key: "localeLanguageAtom",
    default: "en",
});